/**
 * @generated SignedSource<<b8a1cb2b301d6f4c95a61768e007ba91>>
 * @relayHash e37932c82a45e1463294a79cbc5bf76c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 07057d84c2eb1d8562130d87318bdac7bb0c8c05ee3a6cc40dd75b338ad22645

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showInviteButton_provider from '@atlassian/jira-relay-provider/src/jira-invite-button.relayprovider';
import shouldFetchProjectAccess_provider from '@atlassian/jira-relay-provider/src/jira-is-fetch-accesslevel-for-split-share-button-enabled.relayprovider';
import fetchTeamCount_provider from '@atlassian/jira-relay-provider/src/jira-team-button-team-count.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "07057d84c2eb1d8562130d87318bdac7bb0c8c05ee3a6cc40dd75b338ad22645",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": showInviteButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": fetchTeamCount_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": shouldFetchProjectAccess_provider
    }
  }
};

export default node;
